import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import Header from "./Header";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <div style={{ minHeight: "100vh", background: "#F7F7F7" }}>
      <Header />
      <main
        id="main-content"
        style={{
          marginLeft: 220,
          paddingTop: 56,
          minHeight: "100vh",
        }}
      >
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "60vh",
                }}
              >
                <div
                  style={{
                    width: 18,
                    height: 18,
                    border: "1.5px solid #E5E7EB",
                    borderTopColor: "#16A34A",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              </div>
            }
          >
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      <Notification />
    </div>
  );
};
